@import '../../../utils/global.module.less';

.panelRowTitle {
    font-family: LustTextItalic;
    font-weight: 200;
    padding: @title-padding;
    font-size: 22px;
    color: black;
}
